<div class="container">
    <div class="row">
        <div class="col-12 mb-5">
            <app-toolkit-page-title title="Ricerca Utente"></app-toolkit-page-title>
            <div class="card">
                <div class="card-body">
                    <form class="form" role="form" [formGroup]="criteriaForm" (ngSubmit)="submitForm(true)">
                        <div class="form-row">
                            <div class="form-group col-md-3">
                                <label for="codiceFiscale">Codice fiscale</label>
                                <input class="form-control" id="codiceFiscale" formControlName="codiceFiscale" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="cognome">Cognome</label>
                                <input class="form-control" id="cognome" formControlName="cognome" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="nome">Nome</label>
                                <input class="form-control" id="nome" formControlName="nome" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="email">Email</label>
                                <input class="form-control" id="email" formControlName="email" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="emailIstituzionale">Email istituzionale</label>
                                <input class="form-control" id="emailIstituzionale" formControlName="emailIstituzionale" type="text">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="ente">Ente</label>
                                <select class="form-control" formControlName="ente" id="ente">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let ente of datalist.ente" [ngValue]="ente.id">{{ ente.descrizione }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="ruolo">Ruolo</label>
                                <select class="form-control" formControlName="ruolo" id="ruolo">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option *ngFor="let ruolo of datalist.ruolo" [ngValue]="ruolo.id">{{ ruolo.descrizione }}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-3">
                                <label for="status">Stato</label>
                                <select class="form-control" formControlName="status" id="status">
                                    <option [ngValue]="null">Seleziona un'opzione...</option>
                                    <option [ngValue]="1">In approvazione</option>
                                    <option [ngValue]="2">Approvato</option>
                                    <option [ngValue]="3">Rifiutato</option>
                                </select>
                            </div>
                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-outline-primary" (click)="resetForm()">Pulisci</button>
                            <button type="submit" class="btn btn-primary">Ricerca</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card mt-4">
                <div class="card-body">
                    <h6 id="table_description">Risultati ricerca</h6>
                    <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                        <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                            <thead class="thead-light">
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Cognome</th>
                                    <th scope="col">Nome</th>
                                    <th scope="col">Codice fiscale</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Email istituzionale</th>
                                    <th scope="col">ENTE</th>
                                    <th scope="col">Ruolo</th>
                                    <th scope="col">Stato</th>
                                    <th scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of tableData">
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.cognome }}</td>
                                    <td>{{ item.nome }}</td>
                                    <td>{{ item.codiceFiscale }}</td>
                                    <td>{{ item.email }}</td>
                                    <td>{{ item.emailIstituzionale }}</td>
                                    <td>{{ item.ente | anagraficaEnte: (datalist.ente || []) }}</td>
                                    <td>{{ item.ruolo | anagraficaRuolo: (datalist.ruolo || []) }}</td>
                                    <td>{{ item.status | anagraficaUtenteStatus }}</td>
                                    <td class="actions">
                                        <button aria-label="modifica" type="button" (click)="edit(item, modalViewDetails)" class="btn btn-xs btn-outline-primary" container="body" ngbTooltip="Modifica utente">
                                            <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                                            Modifica
                                        </button>
                                    </td>
                                </tr>
                                <tr *ngIf="!tableData.length">
                                    <td colspan="10"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ngb-pagination
                        *ngIf="tableData.length"
                        [(page)]="paginator.page"
                        [pageSize]="paginator.size"
                        [collectionSize]="paginator.total"
                        (pageChange)="onPageChange($event)"
                        [maxSize]="5"
                        ></ngb-pagination>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #modalViewDetails let-modalViewDetails>
	<div class="modal-header">
		<h4 class="modal-title">Dettaglio utente</h4>
		<button type="button" class="close" aria-label="Close" (click)="modalViewDetails.close()">
            <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
        </button>
	</div>
	<div class="modal-body">
        <form class="form" role="form">
            <app-toolkit-utente-form-utente [formGroup]="currentUtenteForm" [datalist]="datalist"></app-toolkit-utente-form-utente>
        </form>
    </div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-primary" (click)="modalViewDetails.close()">Chiudi</button>
		<button type="button" class="btn btn-primary" (click)="edit_confirm()">Salva</button>
	</div>
</ng-template>